import { BackendErrorCode } from '@/modules/common/api/errors';

export const INVOICE_SYNC_ERROR_I18N_KEYS: Record<number, string> = {
  [BackendErrorCode.ENTITY_SYNC_INTERNAL_ERROR]: 'syncError.internal',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_AUTHENTICATION_ERROR]: 'syncError.authentication',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_PERMISSION_ERROR]: 'syncError.permission',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_SERVICE_UNAVAILABLE]: 'syncError.serviceUnavailable',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_RATE_LIMIT_ERROR]: 'syncError.rateLimit',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_GENERAL_ERROR]: 'syncError.general',
};
